import { useTranslation } from "react-i18next"

import { useUserSettings } from "@/contexts"
import { getCurrencySymbol } from "@/utils/currency"

interface UseCurrencySymbolProps {
  includeSpacing: boolean
}

/**
 * The useCurrencySymbol service returns the currency symbol string that should displayed based on the user's settings
 *
 * @returns The currency symbol string
 * @example
 * const currencySymbol = useCurrencySymbol(i18n.language, { includeSpacing: true })
 */
export const useCurrencySymbol = (
  props: UseCurrencySymbolProps = { includeSpacing: false }
): string => {
  const { currency } = useUserSettings()
  const { i18n } = useTranslation()

  const symbol = getCurrencySymbol(i18n.language, currency, {
    includeSpacing: props.includeSpacing,
  })

  return symbol
}
